module.exports = __webpack_public_path__ + "img/8.7b928244.jpg";